import { render, staticRenderFns } from "./xeBlankWidget.vue?vue&type=template&id=9275001a&scoped=true"
import script from "./xeBlankWidget.vue?vue&type=script&lang=js"
export * from "./xeBlankWidget.vue?vue&type=script&lang=js"
import style0 from "./xeBlankWidget.vue?vue&type=style&index=0&id=9275001a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9275001a",
  null
  
)

export default component.exports